import "./bootstrap";
import "bootstrap/js/dist/modal";
import "./app/validate";
import "./app/boxheight";
import "./app/boxoverflown";
import "./app/colorbox";
import "./app/sweetalert2";
import "./app/commons";
import "./app/commons-animations";
import "./app/menumobile";
import "./app/utils";
import "./app/swiper";
import "./app/dotcanvas";
import "./app/cookieconsent";
